import { render, staticRenderFns } from "./treebank.vue?vue&type=template&id=13650f8c&"
import script from "./treebank.vue?vue&type=script&lang=js&"
export * from "./treebank.vue?vue&type=script&lang=js&"
import style0 from "./treebank.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/alpheios-core/alpheios-core/packages/components/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13650f8c')) {
      api.createRecord('13650f8c', component.options)
    } else {
      api.reload('13650f8c', component.options)
    }
    module.hot.accept("./treebank.vue?vue&type=template&id=13650f8c&", function () {
      api.rerender('13650f8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue/components/treebank.vue"
export default component.exports